import { Component, OnInit } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-integer-cell',
  templateUrl: './integer-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class IntegerCellComponent extends InlineEditCellDirective implements OnInit {
  ngOnInit(): void {
    // console.log('#########################################IntegerCellComponent.rowData ####################################');
    // console.log('IntegerCellComponent.rowData', this.rowData);
    // console.log('IntegerCellComponent.fieldName', this.fieldName);
    // console.log('IntegerCellComponent.rowData[this.fieldName]', this.rowData[this.fieldName]);
  }

  abortCellEdit(event: any): void {
    this.rowData[this.fieldName] = parseInt(this.rowData[this.fieldName])
    super.abortCellEdit(event)
  }

  onKeyupEnter(valid: boolean) {
    if (valid) {
      this.isEdited = false
      let parsed = parseInt(this.rowData[this.fieldName])
      if (Number.isNaN(parsed)) {
        parsed = null
      }
      this.rowData[this.fieldName] = parsed
      this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
    }
  }

  triggerEdit() {
    setTimeout(() => {
      this.originalContent = this.rowData[this.fieldName]
      this.isEdited = true
    }, 0)
  }
}
